import type { InstallmentsProduct } from '../../../../products-filter/products-filter-types/pricing-product/pricing-products/fixed-product/fixed-products/installments-product';
import type { FixedProductPriceEstimator } from '../index';

export class InstallmentsPriceEstimator implements FixedProductPriceEstimator<InstallmentsProduct> {
  estimate(product: InstallmentsProduct, _calculationInput: undefined): number {
    return product.variants[0].pricing.priceConfiguration.price * product.variants[0].pricing.priceConfiguration.installments;
  }
}